import React from 'react';
import LandingPage from '../strikegames/LandingPage';
import LoginPage from './Login';

const LoginWrapper: React.FC<{ referalCode?: string }> = ({ referalCode }) => {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Background */}
      <div className="absolute top-0 left-0 w-full h-full z-0">
        <LandingPage />
      </div>

      {/* Foreground - Login */}
      <div className="absolute top-0 left-0 w-full h-full z-10 flex items-center justify-center bg-black bg-opacity-75">
        <LoginPage referalCode={referalCode} />
      </div>
    </div>
  );
};

export default LoginWrapper;
